<template>
    <div>
        <div class="flex xs12 lg10 offset-lg1" style="display:flex; justify-content: space-between">
            <h2>Comentários de avaliação</h2>
            <v-btn @click="$router.go(-1)">Voltar</v-btn>
        </div>
        <div class="flex xs12 lg10 offset-lg1">
            <v-card>
                <v-card-text>
                  <!-- Basic Info -->
                  <div class="subheading mb-3">Informações da Demanda</div>
                  <v-layout row class="pa-2">
                    <v-flex xs3 lg2>
                      <label class="form-label">{{ $t("label.code") }}</label>
                    </v-flex>
                    <v-flex xs9 lg10>
                      <span class="form-value">{{demand.code}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="pa-2">
                    <v-flex xs3 lg2>
                      <label class="form-label">{{ $t("label.system") }}</label>
                    </v-flex>
                    <v-flex xs9 lg10>
                      <span class="form-value">{{demand.system.acronym}} - {{demand.system.name}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="pa-2">
                    <v-flex xs3 lg2>
                      <label class="form-label">{{ $t("label.title") }}</label>
                    </v-flex>
                    <v-flex xs9 lg10>
                      <span class="form-value">{{demand.title}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="pa-2">
                    <v-flex xs3 lg2>
                      <label class="form-label">{{ $t("label.description") }}</label>
                    </v-flex>
                    <v-flex xs9 lg10>
                      <span class="form-value">{{demand.description}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="pa-2">
                    <v-flex xs3 lg2>
                      <label class="form-label">{{ $t("label.averageEvaluationDemands") }}</label>
                    </v-flex>
                    <v-flex xs9 lg10>
                      <span class="form-value"><strong>{{demand.evaluationAverage}}</strong></span>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="pa-2" v-for="(comment, index) in demand.evaluationComments" :key="index">
                    <v-flex xs3 lg2>
                        <label class="form-label">{{ $t('label.comment') + ' ' + parseInt(index + 1) }} </label>
                    </v-flex>
                    <v-flex xs9 lg10>
                        <v-text-field :value="comment" multi-line auto-grow></v-text-field>
                    </v-flex>
                </v-layout>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import utilities from "@/helpers/utilities";

export default {
    data() {
        return {
            loading: true,
        };
    },
    computed: {
        demand() {
            return this.$store.getters.demandComments;
        },
    },
    methods: {
        async getDemandComments() {
            this.loading = true;
            const id = this.$route.params.demandId;

            if (!utilities.isEmptyOrZero(id)) {
                await this.$store.dispatch("loadDemandComments", id);
            }
            this.loading = false;
        }
    },
    beforeMount() {
        this.getDemandComments();
    },
};
</script>



// WEBPACK FOOTER //
// src/components/officesScore/EvaluatedDemandComments.vue